module.exports = __webpack_public_path__ + "static/media/guide_1_m.fa58e96b.gif";